import { render } from "./delcategmodal.vue?vue&type=template&id=2d3f81f9&scoped=true"
import script from "./delcategmodal.vue?vue&type=script&lang=js"
export * from "./delcategmodal.vue?vue&type=script&lang=js"

import "./delcategmodal.vue?vue&type=style&index=0&id=2d3f81f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3f81f9"]])

export default __exports__